import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HttpServices from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import { useCrewCalender } from '../StoreCrewCalendar';
import DayBox from './DayBox';
import NoteBox from './NoteBox';
interface WeekViewProps {
  crewList: any[];
  weekDays: any[];
  shiftList: any[];
  noteList: any[];
  refreshNotes: () => void;
  token: any;

  handleMoreMenu: (type: any, id: any, date: any) => void;
}
const WeekView: React.FC<WeekViewProps> = ({
  crewList,
  weekDays,
  shiftList,
  noteList,
  handleMoreMenu,
  refreshNotes,
  token,
}) => {
  const { setSelectedShiftDate } = useCrewCalender();
  const navigate = useNavigate();
  const getCurrentDateShifts = (shiftDate: string, currentCrew: any) => {
    if (currentCrew) {
      const currentShiftList: any[] = currentCrew.shifts;
      return currentShiftList.filter((item) => item.date === shiftDate);
    } else {
      return [];
    }

    //
  };
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [currentNote, setCurrentNote] = useState<any>(null);
  const [currentNoteDate, setCurrentNoteDate] = useState<any>(null);
  const [currentNoteId, setCurrentNoteId] = useState<any>(null);
  const getCurrentDateNotes = (noteDate: string) => {
    const noteListData: any = noteList.filter((item) => item.date === noteDate);
    return noteListData;
  };
  const handleSave = async () => {
    setLoading(true);
    const reqData: any = { date: currentNoteDate, note: currentNote };
    const endpoint = `${Constants.apiURL + Constants.dailyinfoURL}`;
    let response: any;
    try {
      if (currentNoteId) {
        reqData['id'] = currentNoteId;
      }
      response = await HttpServices.post(endpoint, reqData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.success) {
        setCurrentNote(null);
        setCurrentNoteDate(null);
        setCurrentNoteId(null);
        setDialogOpen(false);
        refreshNotes();
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box sx={{ border: '1px solid #e0e0e0', overflowY: 'scroll' }}>
      {/* Row for content (empty cells) */}

      <Grid container>
        {/* Sidebar */}
        <Grid size={2}>
          <Box
            sx={{
              height: 64,
              display: 'flex',
              alignItems: 'center',
              pl: 2,
              borderRight: '1px solid #e0e0e0',
              backgroundColor: '#fafafa',
            }}
          ></Box>
        </Grid>

        <Grid size={10}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-evenly',
              alignItems: 'center',
            }}
          >
            {weekDays.map((day, idx) => (
              <Box key={idx}>
                <Box
                  sx={{
                    height: 64,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRight:
                      idx !== weekDays.length - 1
                        ? 'none'
                        : '1px solid #e0e0e0',
                  }}
                  className={'maindatebox' + ' AAA_' + weekDays.length}
                >
                  <span
                    style={{
                      backgroundColor: day.active ? '#001e3c' : 'white',
                      color: day.active ? '#00e5ff' : '#424242',
                      borderRadius: day.active ? '25px' : 0,
                      fontWeight: day.active ? 600 : 400,
                      padding: '4px 8px',
                      fontSize: '12px',
                    }}
                  >
                    {day.label}
                  </span>
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: 'flex',
          alignItems: 'stretch',
          minHeight: '64px',
        }}
      >
        <Grid size={2}>
          <Box
            sx={{
              textAlign: 'center',
              minHeight: '64px',
            }}
          >
            <Typography variant="subtitle1" sx={{ margin: '18px auto' }}>
              Daily information
            </Typography>
          </Box>
        </Grid>
        <Grid size={10} sx={{ minHeight: '84px' }}>
          <Box
            sx={{
              display: 'flex',
              height: 'auto',
              justifyContent: 'space-evenly',
              alignItems: 'stretch',
              borderLeft: '1px solid #e0e0e0',
            }}
          >
            {weekDays.map((dayName, idx) => (
              <Box
                key={idx}
                id={'---' + dayName.date + '_____' + weekDays.length}
                className={'daydatebox'}
                sx={{
                  borderRight:
                    idx !== weekDays.length - 1
                      ? '1px solid #e0e0e0'
                      : '1px solid #e0e0e0',
                  background: noteList.find(
                    (item) => item.date === dayName.date
                  )
                    ? '#fef3c7'
                    : 'transparent',
                }}
                onClick={() => {
                  const foundNote = noteList.find(
                    (item) => item.date === dayName.date
                  );
                  if (foundNote) {
                    setCurrentNote(
                      noteList.find((item) => item.date === dayName.date).note
                    );
                  }

                  setCurrentNoteDate(dayName.date);
                  setCurrentNoteId(dayName.date);
                  setDialogOpen(true);
                }}
              >
                <Box
                  id={'mainNoteBox_' + idx}
                  className="mainBox"
                  sx={{
                    cursor: 'pointer',
                    height: 'auto',
                  }}
                  onClick={(event: any) => {
                    if (event.target.id) {
                      setCurrentNote(null);
                      setCurrentNoteDate(dayName.date);
                      setCurrentNoteId(null);
                      setDialogOpen(true);
                    }
                  }}
                >
                  <NoteBox
                    onEventClick={(noteDate: any, noteId: any) => {
                      setCurrentNote(
                        noteList.find((item) => item.id === noteId).note
                      );
                      setCurrentNoteDate(noteDate.date);
                      setCurrentNoteId(noteDate);
                      setDialogOpen(true);
                    }}
                    currentDay={dayName}
                    currentIndex={idx}
                    notes={getCurrentDateNotes(dayName.date)}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
      </Grid>
      {crewList.map((crew) => {
        const crewScheduleEntry: any = shiftList.find(
          (item) => item.crew?.id === crew.id
        );

        return (
          <Grid
            container
            sx={{
              borderTop: '1px solid #e0e0e0',

              alignItems: 'stretch',
            }}
          >
            <Grid size={2}>
              <Box
                sx={{
                  minHeight: 130,

                  textAlign: 'center',
                }}
              >
                <Typography
                  variant="subtitle1"
                  sx={{ margin: '0px auto', padding: '36px 0px' }}
                >
                  {crew.name}
                </Typography>
              </Box>
            </Grid>
            <Grid size={10} sx={{ borderLeft: '1px solid #e0e0e0' }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-evenly',
                  alignItems: 'stretch',
                }}
              >
                {weekDays.map((dayName: any, idx) => (
                  <DayBox
                    key={dayName.date + '_' + idx}
                    onEventClick={(crewId, shiftDate, shiftId) => {
                      setSelectedShiftDate(shiftDate);
                      if (shiftId) {
                        navigate(
                          '/schedules/crews-schedule/' + crew.id + '/' + shiftId
                        );
                      } else {
                        navigate('/schedules/crews-schedule/' + crew.id);
                      }
                    }}
                    handleMoreMenu={handleMoreMenu}
                    currentDay={dayName}
                    currentIndex={idx}
                    weekDays={weekDays}
                    crew={crew}
                    shifts={getCurrentDateShifts(
                      dayName.date,
                      crewScheduleEntry
                    )}
                  />
                ))}
              </Box>
            </Grid>
          </Grid>
        );
      })}

      {/* Daily Information Dialog */}
      <Dialog
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
          setCurrentNote(null);
          setCurrentNoteDate(null);
          setCurrentNoteId(null);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Daily Information - {currentNoteDate}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Note"
            fullWidth
            multiline
            rows={4}
            value={currentNote || ''}
            onChange={(e) => setCurrentNote(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setDialogOpen(false);
              setCurrentNote(null);
              setCurrentNoteDate(null);
              setCurrentNoteId(null);
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            disabled={loading}
            sx={{ color: '#fff' }}
          >
            {loading ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default WeekView;
